import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { currentDomain, currentPath } from "../Index";
import { usePromotionsData } from "../data/PromotionData";
import { useNavigate } from "react-router-dom";
import useAppPromotionTheme from "../hooks/useAppPromotionTheme";
import MasterGamesList from "../data/MasterGamesList";

export default function ColorGameBonanza({ isLightMode }) {
	const isAppPromo = useAppPromotionTheme(isLightMode);
	const { promotionsData } = usePromotionsData();
	const data = promotionsData.find(
		(promo) => promo.title === "Color Game Bonanza",
	);
	const [isMobile, setIsMobile] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 841);
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		if (!data) {
			navigate("/not-found");
		}
	}, [data, navigate]);

	if (!data) return null;

	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>Color Game Bonanza</title>
				<link rel="icon" href="/images/fav.webp" sizes="32x32" />
				<meta name="description" content="ddd" />
				<link rel="canonical" href={`${currentDomain}${currentPath}`} />
			</Helmet>
			<div className="promotion-page-main all-page-main-container-min-height">
				<div className="promotion-page-container main-container-global-adjusted-padding">
					<div className="promotion-tnc-page">
						<div className="promotion-page-breadcrumb">
							<a
								href={
									isAppPromo
										? "/promotion/".replace("/promotion", "/app-promotion")
										: "/promotion"
								}
							>
								Promotions
							</a>
							/ <span>{data.title}</span>
						</div>
						<div className="promotion-tnc-banner">
							<img
								src={isMobile ? data.imgSrc : data.bannerSrc}
								alt={`FGH${data.title}`}
							/>
							<div className="promotion-tnc-content">
								<div className="promotion-tnc-info">
									<div
										className={`promotion-indication-message ${data.promotionMessage.class}`}
									>
										{data.promotionMessage.text}
									</div>
									<h1>Color Game Bonanza</h1>
									<h2>Prize Drop 15,000 Winners</h2>
									<div className="promotion-tnc-period">
										<strong>Event Period: </strong>
										<span>August 06 - August 24, 2026</span>
									</div>
								</div>
								<div className="promotion-tnc-mechanic-content">
									<strong>Terms and Conditions</strong>
									<ol>
										<li>
											15,000 prizes with a prize pool of ₱3,750,000 will be
											given out from 6 August 2026 01:00 to 24 August 2026 00:59
											(GMT+8).
										</li>
										<li>
											There are 2 prize drops during the promotion period,
											running as per the schedule below:
											<p>Schedule:</p>
										</li>
										<ul style={{ marginBottom: "0px" }}>
											<li>
												<strong className="highlight">Phase 1</strong>: 6 August
												01:00 – 17 August 00:59 (GMT+8): with 12,000 winners and
												prizes worth up to ₱3,000,000
											</li>
											<li>
												<strong className="highlight">Phase 2</strong>: 17
												August 01:00 – 24 August 00:59 (GMT+8): with 3,000
												winners and prizes worth up to ₱750,000
											</li>
										</ul>
										<li>
											Prizes will be given in the form of 10 Free Chips, with
											each chip valued at ₱5 or its equivalent in other
											currencies.
										</li>
										<li>
											Free chips can only be used on the following game:{" "}
											<strong className="highlight">Color Game Bonanza.</strong>
										</li>
										<li>Free chips cannot be combined with real money bet.</li>
										<li>
											Total win from each prize is capped at ₱250. Once maximum
											win limit is reached, remaining Free Chips will be
											forfeited.
										</li>
										<li>
											Players can choose to play Free Chips instantly or later.
											Free Chips will be valid for 3 days from the time of
											awarding, after which they will expire.
										</li>
										<li>
											Winnings from Free Chips has no wagering requirement.
										</li>
										<li>
											Each player may win prizes from both phase 1 and phase 2.
										</li>

										<li>
											Pragmatic Play reserves the right to amend, suspend or
											cancel the promotion at any time and without prior notice.
										</li>
									</ol>
									{!isAppPromo && (
										<>
											<strong>Featured Game</strong>
											<MasterGamesList
												limit={1}
												livegames="on"
												customQualifiedGames={[
													{
														provider: "Pragmatic",
														gameName: "Color Game Bonanza",
													},
												]}
												linkTo={null}
												headerText={null}
												subtext={null}
												headerTag="h2"
											/>
										</>
									)}
									<br />
									<strong>Phase 1: 6-17 August</strong>
									<div className="table-wrapper">
										<table
											className="promotion-tnc-table"
											style={{ minWidth: "0" }}
										>
											<thead>
												<tr>
													<th colSpan={2}></th>
												</tr>
												<tr>
													<th>Number of Winners</th>
													<th>Cash Prizes</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>12,000</td>
													<td>10 Free Chips</td>
												</tr>
											</tbody>
										</table>
									</div>
									<br />
									<strong>Phase 1: 17-24 August</strong>
									<div className="table-wrapper">
										<table
											className="promotion-tnc-table"
											style={{ minWidth: "0" }}
										>
											<thead>
												<tr>
													<th colSpan={2}></th>
												</tr>
												<tr>
													<th>Number of Winners</th>
													<th>Cash Prizes</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>3,000</td>
													<td>10 Free Chips</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div className="promotion-tnc-cta">
										<a
											href="https://pp88.asia/tl/color-game-bonanza-prize-drops/"
											className="promotion-cta-btn"
											style={{ cursor: "pointer" }}
											target="_blank"
											rel="noreferrer"
										>
											View Full T&C
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
